import { Component } from '@angular/core';

@Component({
  selector: 'bi-access-denied',
  standalone: false,
  templateUrl: './access-denied.component.html',
  styleUrl: './access-denied.component.scss'
})
export class AccessDeniedComponent {

}
